import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_ksba56pbf3: FaireCollectionEntity = {
  token: "pbc_ksba56pbf3",
  type: "collection",
  name: "Classic Christmas 🎄🎁 PREORDER",
  heroImageUrl:
    "https://cdn.faire.com/fastly/570ae5b2d56e3121b48ce31a4280de9ce932ea4dfbbb906671edd1f7e9d3c7fc.jpeg",
  itemCount: 2,
  description:
    "Cozy sweaters, dresses for twirling, plus comfortable & classic outfits for holly jolly holiday fun!\n\n**This collection is on preorder and will ship the week of 9/15**",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:36.609Z",
    importedBy: "entity-db-import-collections",
  },
};
